module.exports = __webpack_public_path__ + "static/img/sjp_app.728f065d.jpg";